module.exports = "<ul>\n<li>5+ лет работы в IT проектах различного уровня</li>\n<li>Богатый опыт работы с Ruby, Rails и сопутствующей инфраструктурой</li>\n<li>Отличные знания баз данных (PostgreSQL, Redis, RabbitMQ)</li>\n<li>Опыт фронтенд разработки Javascript (Angular, Vue)</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/summary_ru.md
// module id = jmSW
// module chunks = 1